import { api } from "../../services/api"
import { listAllWorkOrderCSSApi, listInvoiceCSSApi, cssCurrentStatus, cssGradationApi, noDueListApi }  from "../../services/apiVariables" 
import { GetMonthYear } from '@src/function.js'

// ----------------------Raw Approval Screen-----------------------------
export function CSSWorkOrderDetails(offset) {
    return (dispatch) => {  
     dispatch({ type: 'CSS_WO_LOADING' })  
    listAllWorkOrderCSSApi.addOffset = `${GetMonthYear()}&BusinessUnit=${offset}`
    api(listAllWorkOrderCSSApi).then(response => response.json())  // convert to json
    .then(
         data => dispatch({ type: 'CSS_WO_SUCCESS', data }),
         error => dispatch({ type:'CSS_WO_ERROR', error: error.message || 'Unexpected Error!!!' })
     )    
    }
}

export function CSSWOInvoiceDetails(offset) {
	 return (dispatch) => { 
    dispatch({ type: 'CSS_INVOICE_LOADING' })  
	 	 listInvoiceCSSApi.addOffset = `${offset}`
		     api(listInvoiceCSSApi).then(response => response.json()) 
          .then(
               data => dispatch({ type: 'CSS_INVOICE_SUCCESS', data }),
               error => dispatch({ type:'CSS_INVOICE_ERROR', error: error.message || 'Unexpected Error!!!' })
           ) 
	 }
}


export function CSSCurrentStatusDetails(offset) {
    return (dispatch) => { 
     dispatch({ type: 'CSS_STATUS_LOADING' }) 
    cssCurrentStatus.addOffset = `BusinessUnit=${offset}&MonthName=${GetMonthYear()}`
    api(cssCurrentStatus).then(response => response.json()) 
    .then(
           data => dispatch({ type: 'CSS_STATUS_SUCCESS', data }),
           error => dispatch({ type:'CSS_STATUS_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

export function CSSCurrentStatusDetailsWithDateRange(offset,startDate,endDate) {
    return (dispatch) => { 
     dispatch({ type: 'CSS_STATUS_LOADING_WITH_DATERANGE' }) 
    cssCurrentStatus.addOffset = `BusinessUnit=${offset}&MonthName=${GetMonthYear()}&StartMonthName=${startDate}&EndMonthName=${endDate}`
    api(cssCurrentStatus).then(response => response.json()) 
    .then(
           data => dispatch({ type: 'CSS_STATUS_WITH_DATERANGE_SUCCESS', data }),
           error => dispatch({ type:'CSS_STATUS_WITH_DATERANGE_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

export function CSSGradationDetails() {
    return (dispatch) => { 
     dispatch({ type: 'CSS_GRADATION_LOADING' }) 
    api(cssGradationApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'CSS_GRADATION_SUCCESS', data }),
           error => dispatch({ type:'CSS_GRADATION_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}



export function CSSNoDueListDetails() {
    return (dispatch) => { 
     dispatch({ type: 'CSS_NODUELIST_LOADING' }) 
    api(noDueListApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'CSS_NODUELIST_SUCCESS', data }),
           error => dispatch({ type:'CSS_NODUELIST_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}